import { type Node } from "prosemirror-model";
import { type Transaction } from "prosemirror-state";

import { type CellPosition } from "./findAncestorCell";

export const replaceCell = ({
	tr,
	node,
	ancestorCell,
}: {
	tr: Transaction;
	node: Node[];
	ancestorCell: CellPosition;
}): Transaction => {
	return tr.replaceWith(ancestorCell.before, ancestorCell.after, node);
};
